import React , { useEffect, useState, useRef }from 'react';
import Carousel from 'react-multi-carousel';

const responsive = {
    all: {
        breakpoint: { max: 9999, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};
const Slider = ({ slider }) => {
    const items = JSON.parse(slider);
    const hasMoreThanOneSlide = items.length > 1;

    const [autoPlay, setAutoPlay] = useState(true);
    const touchStartX = useRef(0);
    const touchStartY = useRef(0);
    const touchMoveX = useRef(0);
    const touchMoveY = useRef(0);

    useEffect(() => {
        const handleTouchStart = (e) => {
            setAutoPlay(false);
            touchStartX.current = e.touches[0].clientX;
            touchStartY.current = e.touches[0].clientY;
        };

        const handleTouchMove = (e) => {
            touchMoveX.current = e.touches[0].clientX;
            touchMoveY.current = e.touches[0].clientY;

            const deltaX = touchMoveX.current - touchStartX.current;
            const deltaY = touchMoveY.current - touchStartY.current;

            if (Math.abs(deltaX) > Math.abs(deltaY) && e.cancelable) {
                e.preventDefault();
            }
        };

        const handleTouchEnd = () => {
            setAutoPlay(true);
        };

        const carouselElement = document.querySelector('.slider-block');

        if (carouselElement) {
            carouselElement.addEventListener('touchstart', handleTouchStart);
            carouselElement.addEventListener('touchmove', handleTouchMove, { passive: false });
            carouselElement.addEventListener('touchend', handleTouchEnd);
        }

        return () => {
            if (carouselElement) {
                carouselElement.removeEventListener('touchstart', handleTouchStart);
                carouselElement.removeEventListener('touchmove', handleTouchMove);
                carouselElement.removeEventListener('touchend', handleTouchEnd);
            }
        };
    }, []);

    return (
        <Carousel
            swipeable={true}
            draggable={false}
            showDots={true}
            responsive={responsive}
            containerClass="slider-block"
            dotListClass="slider-block__dots"
            itemClass="slider-block__item"
            keyBoardControl={true}
            infinite={hasMoreThanOneSlide}
            arrows={true}
            autoPlay={autoPlay}
            autoPlaySpeed={5000}
            pauseOnHover={true}
        >
            {items.map((item, index) => {
                const textColor = item.FontColor ? item.FontColor : "#fff";
                const showOnMobile = item.ShowOnlyOnMobile ? "show-only-mobile" : "";
                const [isWideScreen, setIsWideScreen] = useState(false);

                useEffect(() => {
                  const checkWindowWidth = () => {
                    setIsWideScreen(window.innerWidth > 640);
                  };
                  checkWindowWidth();
                  window.addEventListener('resize', checkWindowWidth);
                  return () => {
                    window.removeEventListener('resize', checkWindowWidth);
                  };
                }, []);

                return (
                    <>
                    {item.LinkUrl && isWideScreen && showOnMobile ?
                    <a href={item.LinkUrl}>
                        <div className="slider-block__item-inner" key={`figure${index}`} style={{ "--text-color": textColor }}>
                            <div className={`slider-block__media-wrapper ${item.Overlay ? "slider-block__media-wrapper--overlay" : ""}`}>
                                {item.Video &&
                                    <>
                                        <video className={`slider-block__video ${item.MobileVideo ? "slider-block__video--hide-in-mobile" : ""} `} playsInline webkit-playsinline="true" autoPlay muted loop >
                                            <source src={item.VideoUrl.Url} type={item.VideoUrl.VideoFormat} media="(max-width:639px)" />
                                        </video>
                                        {item.MobileVideo &&
                                        <video className='slider-block__video slider-block__video--hide-in-desktop ' playsInline webkit-playsinline="true" autoPlay muted loop >
                                            <source src={item.VideoMobileUrl.Url} type={item.VideoMobileUrl.VideoFormat} media="(max-width:639px)" />
                                        </video>}
                                    </>
                                }
                                {item.Image &&
                                    <>
                                        <figure className={`slider-block__figure ${item.MobileImage ? "slider-block__figure--hide-in-mobile" : ""} `} dangerouslySetInnerHTML={{ __html: item.ImageUrl.Url }}></figure>
                                        {item.MobileImage &&
                                            <figure className='slider-block__figure slider-block__figure--hide-in-desktop'
                                            dangerouslySetInnerHTML={{ __html: item.ImageMobileUrl.Url }}></figure>
                                        }
                                    </>
                                }
                            </div>
                            <div className={`slider-block__content ${item.BannerDesign ? "slider-block__content--" + item.BannerDesign.toLowerCase() : ""} `} >
                                <div className={`slider-block__plate ${showOnMobile}`} style={{ background: item.BannerBackgroundColor }} />
                                {item.Title && item.MainTitle && (
                                    <h1 className={`slider-block__title ${showOnMobile}`}
                                    >{item.Title}</h1>
                                )}
                                {item.Title && !item.MainTitle && (
                                    <h2 className={`slider-block__title ${showOnMobile}`}>{item.Title}</h2>
                                )}
                                {item.Text && (
                                    <div dangerouslySetInnerHTML={{ __html: item.Text.Value }} className={`slider-block__text ${showOnMobile}`}
                                    ></div>
                                )}
                                {item.ActionText && item.LinkUrl &&
                                    <a
                                        href={item.LinkUrl}
                                        role="button"
                                        className={`button 
                                        ${item.ButtonDesign} 
                                        ${item.ButtonSize}
                                        ${showOnMobile}
                                        `}
                                    >
                                        {item.ActionText}
                                    </a>
                                }
                            </div>
                        </div>
                    </a>
                    : 
                    <div className="slider-block__item-inner" key={`figure${index}`} style={{ "--text-color": textColor }}>
                    {item.LinkUrl && !item.ActionText ? 
                        <a href={item.LinkUrl}>
                            <div className={`slider-block__media-wrapper ${item.Overlay ? "slider-block__media-wrapper--overlay" : ""}`}>
                                {item.Video &&
                                    <>
                                        <video className={`slider-block__video ${item.MobileVideo ? "slider-block__video--hide-in-mobile" : ""} `} playsInline webkit-playsinline="true" autoPlay muted loop >
                                            <source src={item.VideoUrl.Url} type={item.VideoUrl.VideoFormat} media="(max-width:639px)" />
                                        </video>
                                        {item.MobileVideo &&
                                        <video className='slider-block__video slider-block__video--hide-in-desktop ' playsInline webkit-playsinline="true" autoPlay muted loop >
                                            <source src={item.VideoMobileUrl.Url} type={item.VideoMobileUrl.VideoFormat} media="(max-width:639px)" />
                                        </video>}
                                    </>
                                }
                                {item.Image &&
                                    <>
                                        <figure className={`slider-block__figure ${item.MobileImage ? "slider-block__figure--hide-in-mobile" : ""} `} dangerouslySetInnerHTML={{ __html: item.ImageUrl.Url }}></figure>
                                        {item.MobileImage &&
                                            <figure className='slider-block__figure slider-block__figure--hide-in-desktop'
                                            dangerouslySetInnerHTML={{ __html: item.ImageMobileUrl.Url }}></figure>
                                        }
                                    </>
                                }
                            </div>
                        </a>
                        : 
                        <div className={`slider-block__media-wrapper ${item.Overlay ? "slider-block__media-wrapper--overlay" : ""}`}>
                                {item.Video &&
                                    <>
                                        <video className={`slider-block__video ${item.MobileVideo ? "slider-block__video--hide-in-mobile" : ""} `} playsInline webkit-playsinline="true" autoPlay muted loop >
                                            <source src={item.VideoUrl.Url} type={item.VideoUrl.VideoFormat} media="(max-width:639px)" />
                                        </video>
                                        {item.MobileVideo &&
                                        <video className='slider-block__video slider-block__video--hide-in-desktop ' playsInline webkit-playsinline="true" autoPlay muted loop >
                                            <source src={item.VideoMobileUrl.Url} type={item.VideoMobileUrl.VideoFormat} media="(max-width:639px)" />
                                        </video>}
                                    </>
                                }
                                {item.Image &&
                                    <>
                                        <figure className={`slider-block__figure ${item.MobileImage ? "slider-block__figure--hide-in-mobile" : ""} `} dangerouslySetInnerHTML={{ __html: item.ImageUrl.Url }}></figure>
                                        {item.MobileImage &&
                                            <figure className='slider-block__figure slider-block__figure--hide-in-desktop'
                                            dangerouslySetInnerHTML={{ __html: item.ImageMobileUrl.Url }}></figure>
                                        }
                                    </>
                                }
                            </div>
                        }
                        {item.LinkUrl && !item.ActionText ? 
                            <a href={item.LinkUrl}>
                        <div className={`slider-block__content ${item.BannerDesign ? "slider-block__content--" + item.BannerDesign.toLowerCase() : ""} `} >
                            <div className={`slider-block__plate ${showOnMobile}`} style={{ background: item.BannerBackgroundColor }} />
                            {item.Title && item.MainTitle && (
                                <h1 className={`slider-block__title ${showOnMobile}`}
                                >{item.Title}</h1>
                            )}
                            {item.Title && !item.MainTitle && (
                                <h2 className={`slider-block__title ${showOnMobile}`}
                                >{item.Title}</h2>
                            )}
                            {item.Text && (
                                <div dangerouslySetInnerHTML={{ __html: item.Text.Value }} className={`slider-block__text ${showOnMobile}`}
                                ></div>
                            )}
                            {item.ActionText && item.LinkUrl &&
                                <a
                                    href={item.LinkUrl}
                                    role="button"
                                    className={`button 
                                    ${item.ButtonDesign} 
                                    ${item.ButtonSize}
                                    ${showOnMobile}
                                    `}
                                >
                                    {item.ActionText}
                                </a>
                            }
                        </div>
                        </a>
                        : 
                        <div className={`slider-block__content ${item.BannerDesign ? "slider-block__content--" + item.BannerDesign.toLowerCase() : ""} `} >
                            <div className={`slider-block__plate ${showOnMobile}`} style={{ background: item.BannerBackgroundColor }} />
                            {item.Title && item.MainTitle && (
                                <h1 className={`slider-block__title ${showOnMobile}`}
                                >{item.Title}</h1>
                            )}
                            {item.Title && !item.MainTitle && (
                                <h2 className={`slider-block__title ${showOnMobile}`}
                                >{item.Title}</h2>
                            )}
                            {item.Text && (
                                <div dangerouslySetInnerHTML={{ __html: item.Text.Value }} className={`slider-block__text ${showOnMobile}`}
                                ></div>
                            )}
                            {item.ActionText && item.LinkUrl &&
                                <a
                                    href={item.LinkUrl}
                                    role="button"
                                    className={`button 
                                    ${item.ButtonDesign} 
                                    ${item.ButtonSize}
                                    ${showOnMobile}
                                    `}
                                >
                                    {item.ActionText}
                                </a>
                            }
                        </div>}
                    </div>
                }
                </>
                )
            }
            )
            }
        </Carousel >
    );
};
export default Slider;

